<template>
  <PortalPageShell
    :title="$t('menu.gateManager')"
    :subtitle="$t('portal.gateManager')"
  >
    <ManageGate
      class="portal-page-fill"
      :direction="direction"
      :sort="sort"
      @updateSort="updateSort"
    />
  </PortalPageShell>
</template>

<script>
import PortalPageShell from '../components/layout/PortalPageShell.vue';
import ManageGate from '../components/gate/ManageGate.vue';

export default {
  components: {
    PortalPageShell,
    ManageGate,
  },
  data() {
    return {
      sort: '',
      direction: 'ascending',
    };
  },
  methods: {
    updateSort(value) {
      if (this.sort == value) {
        this.direction = this.direction == 'ascending' ? 'descending' : 'ascending';
      } else {
        this.sort = value;
        this.direction = 'ascending';
      }
    },
  },
};
</script>
